export const createLookAtConstraint =
  (obj: THREE.Object3D, lookatTarget: THREE.Object3D) => () => {
    obj.lookAt(lookatTarget.position);
  };
